export type TypeMode = "prelevement" | "cb" | "cheque";

export interface Mode {
  id: TypeMode;
  texte: string;
  title: string;
}
export const modeRenouvellement: Mode[] = [
  {
    id: "prelevement",
    title: "Par prélèvement",
    texte: "Remplissez notre formulaire avec IBAN et BIC",
  },
  {
    id: "cb",
    title: "Par carte bancaire",
    texte:
      " Vous allez être redirigé vers notre plateforme de paiement sécurisée",
  },
  {
    id: "cheque",
    title: "Par chèque",
    texte: "Envoyez votre chèque à Saga Service Plus",
  },
];
